import React from "react";
import { TextField as Element } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    root: {
        "& .MuiInputBase-root": {
            borderRadius: 10,
            "& .MuiInputBase-input": {
                font: "normal normal normal 16px / 25px Poppins",
                color: "#505050",
            },
        },
        "& .MuiFormLabel-root": {
            font: "normal normal normal 16px/25px Poppins",
            color: "#505050",
            "&.Mui-focused": {
                font: "normal normal normal 19px/21px Poppins",
                color: "#505050",
            },
        },
        "& .MuiOutlinedInput-notchedOutline": {
            border: "1px solid #B0B0B0",
            "& legend": {
                fontSize: "15.5px",
            },
        },
    },
});

const TextField = ({
    id = "outlined-basic",
    size = "normal",
    variant = "outlined",
    label,
    type = "text",
    value = "",
    name,
    fullWidth = { fullWidth },
    ...rest
}) => {
    const classes = useStyles();
    return (
        <Element
            id={id}
            label={label}
            name={name}
            type={type}
            value={value}
            className={classes.root}
            variant={variant}
            size={size}
            fullWidth={fullWidth}
            {...rest}
        />
    );
};

export default TextField;
